<div class="grid form-container otp-verify-container">
  <form [formGroup]="otpForm">
    <div class="col-12">
      <div class="form-field">
        <div class="form-label">
          <label for="otpInput" style="white-space: break-spaces;" translate>label_otp_send_msg</label>
        </div>
        <div class="form-label pt-3">
          <label for="otpInput" style="white-space: break-spaces;" translate>label_enter_otp</label>
        </div>
        <div class="form-control pt-2 pb-2">
          <input
            formControlName="otpInput"
            id="otpInput"
            type="text"
            pInputText
            maxlength="4"
            inputmode="numeric"
            pattern="[0-9]*"
            autocomplete="one-time-code"
            placeholder="0000"
            class="otp-input"
          />
        </div>
        <div class="form-errors"
          *ngIf="otpForm.controls.otpInput.errors && (otpForm.controls.otpInput.dirty || otpForm.controls.otpInput.touched)">
          <div [hidden]="!otpForm.controls.otpInput.errors.required" translate>label_otp_is_required</div>
          <div [hidden]="!otpForm.controls.otpInput.errors.pattern" translate>Enter a valid 4-digit OTP</div>
          <!-- <div [hidden]="!otpForm.controls.otpInput.errors.minlength" translate>OTP must be 4 digits</div> -->
        </div>
      </div>
    </div>

    <div class="col-12 otp-actions-row m-0 pt-0">
      <div class="otp-timer-or-resend">
        <ng-container *ngIf="!showResendLink">
          <span class="otp-timer-label" translate>Resend OTP in</span>
          <span class="otp-timer-value">{{ timerDisplay }}</span>
        </ng-container>
        <a *ngIf="showResendLink" class="otp-resend-link" href="javascript:void(0)" (click)="resendPassword($event)">
          <i class="fa fa-repeat"></i> Resend OTP
        </a>
      </div>
      <div class="form-buttons">
        <button class="negative-button" pButton type="button" icon="fa fa-close" label="Cancel"
          (click)="closeEditForgot($event)"></button>
        <button pButton type="button" class="mr-0" label="Submit" icon="fa fa-check" [disabled]="!otpForm.valid"
          (click)="changePassword($event)"></button>
      </div>
    </div>
  </form>
</div>